// extracted by mini-css-extract-plugin
export default {"content":"ThVIgpI2","button":"fd7ybnn6","description":"zUAL6LKh"};